/* The ONE ruler and padding of the two surfaces that enter from the side — `Sheet` (a column
   docked to the edge: border, square corner, blurred page) and `SidePanel` (a panel floating over
   the page: elevation, rounded leading corner, sharp page). Both read from here so a width or a
   gutter changes in one place for every drawer of the product.

   Three widths, named after the page columns (`page-narrow/medium/wide`): the cap includes the
   gutter, and `wide` IS the `page-narrow` column. Below `sm` (640) every side surface is the whole
   screen — on a phone a 75% drawer squeezes the content and leaves a strip of veil (#4329).
     narrow  28rem  448px  a document or a list — the old voucher document, notifications, histories
     medium  36rem  576px  a richer document — the trip drawer
     wide    48rem  768px  a listing or a sub-screen — rooms (needs ≥ 672 of content), seat map
   Plus ONE width that is not a page column, on purpose: the voucher detail of the new skeleton
   (#5024 — flight, hotel, bus, car, ride) is drawn at 390 and opens at 400 everywhere, the same
   column the Vouchers screen docks it in (#5022). Decided by Victor, 2026-10-16.
     voucher 25rem  400px  the voucher detail of the new skeleton */
export type SideSize = 'narrow' | 'medium' | 'wide' | 'voucher';

export const SIDE_SIZE: Record<SideSize, string> = {
  voucher: 'w-full sm:max-w-[25rem]',
  narrow: 'w-full sm:max-w-[28rem]',
  medium: 'w-full sm:max-w-[36rem]',
  wide: 'w-full sm:max-w-[48rem]',
};

/* The side surface leaves through a Portal, outside the app's top bar that absorbs the device
   cutout on ordinary screens — so it clears the status bar / Dynamic Island and the home indicator
   itself. Outside `viewport-fit=cover` `env()` resolves 0 and nothing moves. */
export const SIDE_SAFE_AREA =
  'pt-[env(safe-area-inset-top,0px)] pb-[env(safe-area-inset-bottom,0px)]';

/* The ✕ is absolute to the popup's border box, not its padding: it drops with the top cutout. */
export const SIDE_CLOSE = 'absolute right-3 top-[calc(0.75rem+env(safe-area-inset-top,0px))]';

/* **24px side gutter, the floor of any drawer** (designer's call). Header, body and footer share
   it so the three fall on the same vertical; the body publishes it as `--page-gutter` so a
   `page-bleed` inside a drawer undoes the drawer's gutter, not a page's. The body's bar is the
   `scrollbar-rail`, inside the right gutter: the padding gives back the rail's width, so the
   content keeps the header's vertical with or without a bar. */
export const SIDE_HEADER = 'flex flex-col gap-0.5 px-6 py-4';
export const SIDE_BODY =
  'scrollbar-rail flex min-h-0 flex-1 flex-col overflow-y-auto pr-[calc(1.5rem-var(--scrollbar-rail))] pb-6 pl-6 [--page-gutter:1.5rem] [&:has(+[data-side-footer])]:pb-0';
/* Same skirt as the `DialogFooter`: hug, in a row, at the right. */
export const SIDE_FOOTER = 'mt-auto flex flex-row justify-end gap-2 px-6 py-4';
export const SIDE_TITLE = 'text-base font-medium text-foreground';
export const SIDE_DESCRIPTION = 'text-sm text-muted-foreground';
